import styled from "styled-components";
import {
  off_black,
  white,
  gray_footer_text,
  off_white,
} from "../constants/styles";

export const BlackTheme = styled.div`
  background-color: ${off_black};
  color: ${white};
`;

export const LightGreyTheme = styled.div`
  background-color: #fafafa;
  color: #333333;
`;

export const FooterTheme = styled.div`
  background-color: ${white};
  color: ${gray_footer_text};

  [data-theme="dark"] & {
    background-color: #0f172a;
    color: #d1d5db;
    border-top: 1px solid rgba(255, 255, 255, 0.06);
  }

  [data-theme="dark"] & a {
    color: #e5e7eb;
  }

  [data-theme="dark"] & a:hover {
    color: #f3f4f6;
  }
`;

export const OffWhiteTheme = styled.div`
  background-color: ${off_white};
  color: ${off_black};
`;
